import { TFunction } from "i18next";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { formatNumber } from "src/utility";

const NOTCH_RADIUS = 20;
const INITIAL_DISCOUNT_SEARCH = {
  name: "",
  categoryCode: "",
};

const rangeLabel = (min: number, max: number, suffix: string) =>
  min === max ? `${formatNumber(min)}${suffix}` : `${formatNumber(min)}-${formatNumber(max)}${suffix}`;

const aggregatedData = {
  points: {
    labelTransform: (items: DiscountItemType[], t: TFunction) => {
      const vals = items.map((i) => i.points ?? 0);
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      return (
        <span>
          <span className="font-inter text-base font-semibold">
            {min === max ? formatNumber(min) : `${formatNumber(min)}-${formatNumber(max)}`}
          </span>
          <span className="text-xs font-normal">{t("Discounts.pointsSuffix")}</span>
        </span>
      );
    },
  },
  totalPrice: {
    labelTransform: (items: DiscountItemType[]) => {
      const vals = items.map((i) => i.totalPrice);
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      return <span>{rangeLabel(min, max, "")}</span>;
    },
  },
  discount: {
    labelTransform: (items: DiscountItemType[], t: TFunction) => {
      const vals = items.map((i) => Number(i.discount));
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      return <span>{rangeLabel(min, max, t("Discounts.discountSuffix"))}</span>;
    },
  },
  validityInDays: {
    labelTransform: (items: DiscountItemType[], t: TFunction) => {
      const vals = items.map((i) => i.validityInDays).filter((v): v is number => v != null);
      if (vals.length === 0) return null;
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      return <span>{rangeLabel(min, max, t("Discounts.daysSuffix"))}</span>;
    },
  },
};

export { NOTCH_RADIUS,INITIAL_DISCOUNT_SEARCH, rangeLabel, aggregatedData };
